/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// Content Truncation functionality
var ContentTruncate = /*#__PURE__*/function () {
  function ContentTruncate(element) {
    _classCallCheck(this, ContentTruncate);
    this.element = element;
    this.textElement = element.querySelector(".content-truncate__text");
    this.toggleButton = element.querySelector(".content-truncate__toggle");
    this.mobileHeight = parseInt(element.dataset.truncateMobileHeight) || parseInt(element.dataset.truncateHeight) || 80;
    this.desktopHeight = parseInt(element.dataset.truncateDesktopHeight) || 120;
    this.isExpanded = false;
    this.breakpoint = 750; // Mobile breakpoint

    this.init();
  }
  _createClass(ContentTruncate, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (!this.textElement || !this.toggleButton) return;

      // Set initial state
      this.checkIfTruncationNeeded();

      // Add event listener
      this.toggleButton.addEventListener("click", function () {
        return _this.toggle();
      });

      // Re-check on window resize
      window.addEventListener("resize", function () {
        return _this.checkIfTruncationNeeded();
      });
    }
  }, {
    key: "getCurrentTruncateHeight",
    value: function getCurrentTruncateHeight() {
      return window.innerWidth < this.breakpoint ? this.mobileHeight : this.desktopHeight;
    }
  }, {
    key: "setTruncateHeight",
    value: function setTruncateHeight(height) {
      this.element.style.setProperty("--truncate-height", "".concat(height, "px"));
    }
  }, {
    key: "checkIfTruncationNeeded",
    value: function checkIfTruncationNeeded() {
      var currentHeight = this.getCurrentTruncateHeight();

      // Check if truncation is enabled for current viewport
      var hasMobileTruncate = this.element.dataset.truncateMobileHeight !== undefined;
      var hasDesktopTruncate = this.element.dataset.truncateDesktopHeight !== undefined;
      var isMobile = window.innerWidth < this.breakpoint;
      if (!isMobile && !hasDesktopTruncate || isMobile && !hasMobileTruncate) {
        this.textElement.classList.remove("is-truncated");
        this.toggleButton.style.display = "none";
        return;
      }

      // Set the truncate height for current viewport
      this.setTruncateHeight(currentHeight);

      // Temporarily remove truncation to measure full height
      this.textElement.classList.remove("is-truncated");
      var fullHeight = this.textElement.scrollHeight;
      if (fullHeight > currentHeight) {
        this.textElement.classList.add("is-truncated");
        this.toggleButton.style.display = "block";
      } else {
        this.toggleButton.style.display = "none";
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.textElement.classList.remove("is-truncated");
        this.toggleButton.setAttribute("aria-expanded", "true");
      } else {
        this.textElement.classList.add("is-truncated");
        this.toggleButton.setAttribute("aria-expanded", "false");
      }
    }
  }]);
  return ContentTruncate;
}(); // Initialize content truncation when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  var truncateElements = document.querySelectorAll("[data-truncate]");
  truncateElements.forEach(function (element) {
    return new ContentTruncate(element);
  });
});

// Re-initialize on Shopify section loads (theme editor)
document.addEventListener("shopify:section:load", function (event) {
  var truncateElements = event.target.querySelectorAll("[data-truncate]");
  truncateElements.forEach(function (element) {
    return new ContentTruncate(element);
  });
});

// Function to open chat via shadow DOM
// function openChatWithUs(event) {
//   // If this is an anchor tag, prevent default navigation
//   if (event && event.preventDefault) {
//     event.preventDefault();
//   }

//   // Find the chat widget in shadow DOM
//   zE("messenger", "open");

//   return false;
// }
// // Find and attach event listeners to chat links
// function findAndAttachChatLinks() {
//   const allLinks = document.querySelectorAll("a");

//   allLinks.forEach((link) => {
//     const linkText = link.textContent.toLowerCase();

//     // Check if the link appears to be a chat link
//     if (linkText.includes("chat")) {
//       // Add click event listener
//       link.addEventListener("click", openChatWithUs);
//     }
//   });

//   // Find the chat widget in shadow DOM
//   zE("messenger", "hide");

//   zE("messenger:on", "open", function () {
//     // Show the chat launcher when chat is opened
//     const style = document.createElement("style");
//     style.textContent = "iframe#launcher { display: block; }";
//     document.head.appendChild(style);
//   });
//   zE("messenger:on", "close", function () {
//     // Hide the chat launcher when chat is closed
//     const style = document.createElement("style");
//     style.textContent = "iframe#launcher { display: none; }";
//     document.head.appendChild(style);
//   });
// }

// // Initialize when DOM is loaded
// document.addEventListener("DOMContentLoaded", findAndAttachChatLinks);

// Function to move monster-protection div to cart form
function moveMonsterProtectionToCartForm() {
  var monsterProtectionDiv = document.querySelector('[class*="monster-protection"], [id*="monster-protection"], div[class*="monster"], div[id*="monster"]');
  var cartForm = document.querySelector('.cart__form');
  if (monsterProtectionDiv && cartForm) {
    // Remove from current location and prepend to cart form
    cartForm.prepend(monsterProtectionDiv);
    console.log('Monster Protection moved to cart form');

    // Stop all observers since we found and moved the element
    stopMonsterProtectionObservers();
    return true; // Indicate success
  }

  return false; // Indicate not found
}

// Store observers globally so they can be stopped
var monsterProtectionObserver = null;
var drawerStateObserver = null;

// Function to stop all observers
function stopMonsterProtectionObservers() {
  if (monsterProtectionObserver) {
    monsterProtectionObserver.disconnect();
    monsterProtectionObserver = null;
    console.log('Monster Protection mutation observer stopped');
  }
  if (drawerStateObserver) {
    drawerStateObserver.disconnect();
    drawerStateObserver = null;
    console.log('Drawer state observer stopped');
  }
}

// Observer to watch for dynamically added monster-protection elements
function observeForMonsterProtection() {
  var cartDrawer = document.querySelector('#cart-drawer, [data-cart-drawer], .drawer--cart');
  if (!cartDrawer || monsterProtectionObserver) return; // Don't create multiple observers

  monsterProtectionObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Element node
          // Check if the added node is the monster-protection div
          if (node.matches && (node.matches('[class*="monster-protection"]') || node.matches('[id*="monster-protection"]') || node.matches('div[class*="monster"]') || node.matches('div[id*="monster"]'))) {
            setTimeout(function () {
              if (moveMonsterProtectionToCartForm()) {
                // Success - stop observing
                return;
              }
            }, 100);
          }

          // Check if the added node contains monster-protection div
          var monsterDiv = node.querySelector && node.querySelector('[class*="monster-protection"], [id*="monster-protection"], div[class*="monster"], div[id*="monster"]');
          if (monsterDiv) {
            setTimeout(function () {
              if (moveMonsterProtectionToCartForm()) {
                // Success - stop observing
                return;
              }
            }, 100);
          }
        }
      });
    });
  });

  // Start observing
  monsterProtectionObserver.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

// Initialize monster protection functionality
document.addEventListener("DOMContentLoaded", function () {
  // Try to move existing monster protection
  setTimeout(function () {
    if (!moveMonsterProtectionToCartForm()) {
      // If not found initially, start observing
      observeForMonsterProtection();
    }
  }, 500);
});

// Handle cart drawer events (when cart is updated or opened)
document.addEventListener('cart:updated', function () {
  setTimeout(function () {
    if (!moveMonsterProtectionToCartForm()) {
      // If not found, restart observing if not already active
      observeForMonsterProtection();
    }
  }, 200);
});

// Handle Shopify section reloads (theme editor)
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('[data-section-type="cart-drawer"]')) {
    setTimeout(function () {
      if (!moveMonsterProtectionToCartForm()) {
        // If not found, restart observing
        observeForMonsterProtection();
      }
    }, 300);
  }
});

// Additional event listeners for cart drawer interactions
document.addEventListener('click', function (event) {
  // Check if cart drawer trigger was clicked
  if (event.target.matches('[data-cart-drawer-open], [data-cart-open], .cart-link, .cart__toggle') || event.target.closest('[data-cart-drawer-open], [data-cart-open], .cart-link, .cart__toggle')) {
    setTimeout(function () {
      if (!moveMonsterProtectionToCartForm()) {
        // If not found, start observing if not already active
        observeForMonsterProtection();
      }
    }, 500);
  }
});

// Listen for cart drawer opening/closing
var cartDrawerElement = document.querySelector('#cart-drawer, [data-cart-drawer]');
if (cartDrawerElement) {
  // Watch for attribute changes that indicate drawer opening
  drawerStateObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
        var target = mutation.target;
        if (target.classList.contains('is-open') || target.classList.contains('active') || target.style.display !== 'none') {
          setTimeout(function () {
            if (!moveMonsterProtectionToCartForm()) {
              // If not found, start observing if not already active
              observeForMonsterProtection();
            }
          }, 200);
        }
      }
    });
  });
  drawerStateObserver.observe(cartDrawerElement, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });
}

// Check if Zendesk Chat (zE) is available
function isZendeskChatAvailable() {
  return typeof window.zE !== 'undefined' && typeof window.zE === 'function';
}

// Observer to watch for zE availability
function observeZendeskChat() {
  // Check if zE is already available
  if (isZendeskChatAvailable()) {
    initializeZendeskChat();
    return;
  }

  // Create an observer to watch for zE becoming available
  var observer = new MutationObserver(function () {
    if (isZendeskChatAvailable()) {
      console.log('Zendesk Chat (zE) is now available');
      initializeZendeskChat();
      observer.disconnect(); // Stop observing once found
    }
  });

  // Start observing changes to the document
  observer.observe(document, {
    childList: true,
    subtree: true
  });

  // Also check periodically in case zE is added via script injection
  var intervalCheck = setInterval(function () {
    if (isZendeskChatAvailable()) {
      console.log('Zendesk Chat (zE) detected via interval check');
      initializeZendeskChat();
      clearInterval(intervalCheck);
      observer.disconnect();
    }
  }, 1000);

  // Stop checking after 30 seconds to avoid infinite polling
  setTimeout(function () {
    clearInterval(intervalCheck);
    observer.disconnect();
    if (!isZendeskChatAvailable()) {
      console.warn('Zendesk Chat widget was not loaded within 30 seconds');
    }
  }, 30000);
}

// Initialize Zendesk Chat functionality
function initializeZendeskChat() {
  // Hide the chat widget initially
  // zE("messenger", "hide");

  zE("messenger:on", "open", function () {
    var style = document.createElement("style");
    style.textContent = "iframe#launcher { display: block; }";
    document.head.appendChild(style);
  });
  zE("messenger:on", "close", function () {
    var style = document.createElement("style");
    style.textContent = "iframe#launcher { display: none; }";
    document.head.appendChild(style);
  });

  // Now attach chat links since zE is available
  findAndAttachChatLinks();
}

// Function to open chat via shadow DOM
function openChatWithUs(event) {
  if (event && event.preventDefault) {
    event.preventDefault();
  }
  if (isZendeskChatAvailable()) {
    zE("messenger", "open");
  } else {
    console.warn('Zendesk Chat widget is not available');
  }
  return false;
}
function openRewards(event) {
  if (event && event.preventDefault) {
    event.preventDefault();
  }
  var rewardsButton = document.getElementById('bon-loyalty-btn');
  if (rewardsButton) {
    rewardsButton.click();
  } else {
    console.warn('Rewards button not found');
  }
  return false;
}

// Find and attach event listeners to chat links
function findAndAttachChatLinks() {
  var allLinks = document.querySelectorAll("a");
  allLinks.forEach(function (link) {
    var linkText = link.textContent.toLowerCase();
    if ((linkText.includes("chat") || link.href.toLowerCase().includes("dtfdirect.zendesk.com")) && !link.href.includes("forceRedirect=true")) {
      link.addEventListener("click", openChatWithUs);
    } else if (linkText.toLowerCase().includes('rewards')) {
      link.addEventListener("click", openRewards);
    }
  });
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  observeZendeskChat();
  var feraRating = document.querySelector('div[data-fera-container="product_reviews_summary"]');
  if (feraRating) {
    feraRating.addEventListener("click", function (e) {
      e.preventDefault();
      var reviewClickable = feraRating.querySelector('[data-fera-component="averageRating"]');
      if (reviewClickable) {
        reviewClickable.click();
      }
    });
  }
});

// Observer to watch for upload button status changes
function observeUploadButton() {
  // Function to check button status and update submit button class
  function checkUploadStatus() {
    var uploadButton = document.querySelector('button[data-uploader-name="Uploaded File"]');
    var submitButton = document.querySelector('.product__submit__item  button[type="submit"]');
    if (uploadButton && submitButton) {
      var isFileUploaded = uploadButton.textContent.trim() === "File Successfully Uploaded";
      if (isFileUploaded) {
        submitButton.classList.remove("uploadkit-not-uploaded");

        // Check if there's an image in the thumbnail container and add reset button
        var thumbnailContainer = document.querySelector('.uploadkit-app-block .uploadkit-thumbnails');
        console.log("Thumbnail Container:", thumbnailContainer);
        if (thumbnailContainer && thumbnailContainer.querySelector('img')) {
          // Check if reset button doesn't already exist
          if (!thumbnailContainer.querySelector('.uploadkit-reset-button')) {
            var resetButton = document.createElement('button');
            resetButton.type = 'button';
            resetButton.className = 'uploadkit-reset-button';
            resetButton.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.37037" y="0.37037" width="19.2593" height="19.2593" rx="9.62963" fill="white"/><rect x="0.37037" y="0.37037" width="19.2593" height="19.2593" rx="9.62963" stroke="black" stroke-width="0.740741"/><path d="M13 13.668L6.33333 7.0013C6.14924 6.81721 6.14924 6.51873 6.33333 6.33463C6.51743 6.15054 6.81591 6.15054 7 6.33463L13.6667 13.0013C13.8508 13.1854 13.8508 13.4839 13.6667 13.668C13.4826 13.8521 13.1841 13.8521 13 13.668Z" fill="black"/><path d="M13.666 6.99997L6.99935 13.6667C6.81525 13.8508 6.51678 13.8508 6.33268 13.6667C6.14859 13.4826 6.14859 13.1841 6.33268 13L12.9994 6.3333C13.1835 6.14921 13.4819 6.14921 13.666 6.3333C13.8501 6.5174 13.8501 6.81588 13.666 6.99997Z" fill="black"/></svg>';
            resetButton.addEventListener('click', function () {
              if (typeof UploadKit !== 'undefined' && UploadKit.resetUploaders) {
                UploadKit.resetUploaders();
              } else {
                console.warn('UploadKit.resetUploaders is not available');
              }
            });
            thumbnailContainer.appendChild(resetButton);
          }
        }
      } else {
        submitButton.classList.add("uploadkit-not-uploaded");
      }
    }
  }

  // Initial check
  checkUploadStatus();

  // Create a MutationObserver to watch for changes
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // Check if nodes were added/removed or text content changed
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        checkUploadStatus();
      }

      // Check if attributes changed on the upload button
      if (mutation.type === 'attributes' && mutation.target.matches('button[data-uploader-name="Uploaded file"]')) {
        checkUploadStatus();
      }
    });
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'data-uploader-name']
  });

  // Also check periodically in case changes are not caught by observer
  setInterval(checkUploadStatus, 1000);
}

// Initialize upload button observer when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  // Add a small delay to ensure all elements are loaded
  setTimeout(observeUploadButton, 500);
});
document.addEventListener('theme:cart:add', function (e) {
  checkCartAvailability();
  handlePrecutTransfers();
});
document.addEventListener('theme:cart:change', function (e) {
  checkCartAvailability();
  handlePrecutTransfers();
});

// Handle precut transfers - add or update specific variant based on items with "Precut my transfers" property
function handlePrecutTransfers() {
  return _handlePrecutTransfers.apply(this, arguments);
} // Helper function to add item to cart
function _handlePrecutTransfers() {
  _handlePrecutTransfers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response, cart, precutCount, precutVariantId, existingPrecutItem;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch('/cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 3:
          response = _context.sent;
          if (response.ok) {
            _context.next = 6;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 6:
          _context.next = 8;
          return response.json();
        case 8:
          cart = _context.sent;
          // Count items that have the "Precut my transfers" property set to "yes"
          precutCount = cart.items.reduce(function (count, item) {
            if (item.properties && item.properties['Precut my transfers'] === 'yes' || item.properties && item.properties['Precut my transfers'] === 'Yes') {
              return count + item.quantity;
            }
            return count;
          }, 0);
          console.log('Precut transfers count:', precutCount);
          precutVariantId = '51495562772781'; // Find if the precut variant is already in cart
          existingPrecutItem = cart.items.find(function (item) {
            return item.variant_id.toString() === precutVariantId;
          });
          if (!(precutCount > 0)) {
            _context.next = 26;
            break;
          }
          if (!(existingPrecutItem && existingPrecutItem.quantity !== precutCount)) {
            _context.next = 20;
            break;
          }
          _context.next = 17;
          return updateCartItem(existingPrecutItem.key, precutCount);
        case 17:
          console.log("Updated precut transfers quantity to ".concat(precutCount));
          _context.next = 24;
          break;
        case 20:
          if (existingPrecutItem) {
            _context.next = 24;
            break;
          }
          _context.next = 23;
          return addToCart(precutVariantId, precutCount);
        case 23:
          console.log("Added precut transfers with quantity ".concat(precutCount));
        case 24:
          _context.next = 30;
          break;
        case 26:
          if (!existingPrecutItem) {
            _context.next = 30;
            break;
          }
          _context.next = 29;
          return updateCartItem(existingPrecutItem.key, 0);
        case 29:
          console.log('Removed precut transfers - no items need it');
        case 30:
          _context.next = 35;
          break;
        case 32:
          _context.prev = 32;
          _context.t0 = _context["catch"](0);
          console.error('Error handling precut transfers:', _context.t0);
        case 35:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 32]]);
  }));
  return _handlePrecutTransfers.apply(this, arguments);
}
function addToCart(_x, _x2) {
  return _addToCart.apply(this, arguments);
} // Helper function to update cart item quantity
function _addToCart() {
  _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(variantId, quantity) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });
        case 3:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 6;
            break;
          }
          throw new Error("Failed to add to cart: ".concat(response.status));
        case 6:
          // Trigger cart refresh
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            bubbles: true
          }));
          _context2.next = 9;
          return response.json();
        case 9:
          return _context2.abrupt("return", _context2.sent);
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](0);
          console.error('Error adding to cart:', _context2.t0);
          throw _context2.t0;
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 12]]);
  }));
  return _addToCart.apply(this, arguments);
}
function updateCartItem(_x3, _x4) {
  return _updateCartItem.apply(this, arguments);
}
function _updateCartItem() {
  _updateCartItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key, quantity) {
    var response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: key,
              quantity: quantity
            })
          });
        case 3:
          response = _context3.sent;
          if (response.ok) {
            _context3.next = 6;
            break;
          }
          throw new Error("Failed to update cart: ".concat(response.status));
        case 6:
          // Trigger cart refresh
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            bubbles: true
          }));
          _context3.next = 9;
          return response.json();
        case 9:
          return _context3.abrupt("return", _context3.sent);
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](0);
          console.error('Error updating cart:', _context3.t0);
          throw _context3.t0;
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 12]]);
  }));
  return _updateCartItem.apply(this, arguments);
}
function checkCartAvailability(_x5) {
  return _checkCartAvailability.apply(this, arguments);
} // Function to move MW fee div to cart form
function _checkCartAvailability() {
  _checkCartAvailability = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(cart) {
    var response, cartBulkBanner, cartPageBulkBanner, qualifyingProducts, hasQualifyingProducts, _qualifyingProducts, _hasQualifyingProducts;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return fetch('/cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 3:
          response = _context4.sent;
          if (response.ok) {
            _context4.next = 6;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 6:
          _context4.next = 8;
          return response.json();
        case 8:
          cart = _context4.sent;
          cartBulkBanner = document.querySelector("cart-drawer .buy-bulk-block");
          cartPageBulkBanner = document.querySelector(".cart .buy-bulk-block"); // Handle cart drawer bulk banner
          if (cartBulkBanner) {
            qualifyingProducts = cartBulkBanner.dataset.qualifyingProducts ? cartBulkBanner.dataset.qualifyingProducts.split(',').map(function (id) {
              return parseInt(id.trim());
            }) : [];
            hasQualifyingProducts = cart.items.some(function (item) {
              return qualifyingProducts.includes(item.product_id);
            });
            if (cart.items.length > 0 && hasQualifyingProducts) {
              cartBulkBanner.classList.remove('hidden');
            } else {
              cartBulkBanner.classList.add('hidden');
            }
          }

          // Handle cart page bulk banner
          if (cartPageBulkBanner) {
            _qualifyingProducts = cartPageBulkBanner.dataset.qualifyingProducts ? cartPageBulkBanner.dataset.qualifyingProducts.split(',').map(function (id) {
              return parseInt(id.trim());
            }) : [];
            _hasQualifyingProducts = cart.items.some(function (item) {
              return _qualifyingProducts.includes(item.product_id);
            });
            if (cart.items.length > 0 && _hasQualifyingProducts) {
              cartPageBulkBanner.classList.remove('hidden');
            } else {
              cartPageBulkBanner.classList.add('hidden');
            }
          }
          _context4.next = 18;
          break;
        case 15:
          _context4.prev = 15;
          _context4.t0 = _context4["catch"](0);
          console.error('Failed to fetch cart:', _context4.t0);
        case 18:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 15]]);
  }));
  return _checkCartAvailability.apply(this, arguments);
}
function moveMwFeeToCartForm() {
  var cartForm = document.querySelector('.cart__form');
  if (!cartForm) {
    return false; // No cart form found
  }

  // First, check if there's already an MW fee element in the cart form
  var existingMwFeeInCartForm = cartForm.querySelector('.mw-fee--type-cart, .mw-fee[data-fee-target-key]');
  if (existingMwFeeInCartForm) {
    // MW fee already exists in cart form, remove any duplicates from other locations
    var otherMwFeeElements = document.querySelectorAll('.cart__total .mw-fee--type-cart, .mw-fee--type-cart:not(.cart__form .mw-fee--type-cart), .mw-fee[data-fee-target-key]:not(.cart__form .mw-fee[data-fee-target-key])');
    otherMwFeeElements.forEach(function (element) {
      if (!cartForm.contains(element)) {
        console.log('Removing duplicate MW Fee element from DOM');
        element.remove();
      }
    });

    // Add price span to MW fee if not already added
    addMwFeePriceSpan(existingMwFeeInCartForm);

    // Add event listener to the existing MW fee checkbox
    attachMwFeeCheckboxListener();
    console.log('MW Fee already exists in cart form, duplicates removed');
    return true;
  }

  // No MW fee in cart form yet, look for one to move
  // Search for MW fee elements with multiple possible selectors
  var mwFeeDiv = document.querySelector('.cart__total .mw-fee--type-cart') || document.querySelector('.mw-fee--type-cart') || document.querySelector('.mw-fee[data-fee-target-key]') || document.querySelector('[data-fee-target-key]');
  if (mwFeeDiv && cartForm) {
    // Remove any other MW fee elements before moving this one
    var _otherMwFeeElements = document.querySelectorAll('.mw-fee--type-cart, .mw-fee[data-fee-target-key], [data-fee-target-key]');
    _otherMwFeeElements.forEach(function (element) {
      if (element !== mwFeeDiv) {
        console.log('Removing duplicate MW Fee element from DOM before moving');
        element.remove();
      }
    });

    // Move the MW fee element to cart form
    cartForm.prepend(mwFeeDiv);
    console.log('MW Fee moved to cart form');

    // Add price span to MW fee after moving
    addMwFeePriceSpan(mwFeeDiv);

    // Add event listener to MW fee checkbox after moving
    attachMwFeeCheckboxListener();

    // Stop the MW fee observer since we found and moved the element
    stopMwFeeObserver();
    return true; // Indicate success
  }

  return false; // Indicate not found
}

// Function to calculate MW fee price
function calculateMwFeePrice() {
  return _calculateMwFeePrice.apply(this, arguments);
} // Function to add price span to MW fee
function _calculateMwFeePrice() {
  _calculateMwFeePrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var response, cart, excludedProductId, eligibleTotal, eligibleTotalInDollars, calculatedFee, finalFee;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return fetch('/cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 3:
          response = _context5.sent;
          if (response.ok) {
            _context5.next = 6;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 6:
          _context5.next = 8;
          return response.json();
        case 8:
          cart = _context5.sent;
          excludedProductId = 10112772931885; // Additional fees product ID
          // Calculate cart total excluding the additional fees product
          eligibleTotal = cart.items.reduce(function (total, item) {
            if (item.product_id !== excludedProductId) {
              return total + item.price * item.quantity;
            }
            return total;
          }, 0); // Convert from cents to dollars
          eligibleTotalInDollars = eligibleTotal / 100; // Calculate 25% of eligible total
          calculatedFee = eligibleTotalInDollars * 0.25; // Apply minimum of $25
          finalFee = Math.max(calculatedFee, 25);
          return _context5.abrupt("return", finalFee);
        case 17:
          _context5.prev = 17;
          _context5.t0 = _context5["catch"](0);
          console.error('Error calculating MW fee price:', _context5.t0);
          return _context5.abrupt("return", 25);
        case 21:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 17]]);
  }));
  return _calculateMwFeePrice.apply(this, arguments);
}
function addMwFeePriceSpan(_x6) {
  return _addMwFeePriceSpan.apply(this, arguments);
} // Function to update MW fee price display
function _addMwFeePriceSpan() {
  _addMwFeePriceSpan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(mwFeeElement) {
    var controlTitle, priceSpan, calculatedPrice;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          controlTitle = mwFeeElement.querySelector('.mw-fee__control-title');
          if (!controlTitle) {
            _context6.next = 8;
            break;
          }
          priceSpan = controlTitle.querySelector('.mw-fee-price-span');
          if (!priceSpan) {
            priceSpan = document.createElement('span');
            priceSpan.className = 'mw-fee-price-span';
            priceSpan.style.marginLeft = '3px';
            priceSpan.style.fontSize = '16px';
            controlTitle.appendChild(priceSpan);
            console.log('MW Fee price span added');
          }

          // Calculate and update the price
          _context6.next = 6;
          return calculateMwFeePrice();
        case 6:
          calculatedPrice = _context6.sent;
          priceSpan.textContent = "$".concat(calculatedPrice.toFixed(2));
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _addMwFeePriceSpan.apply(this, arguments);
}
function updateMwFeePrice() {
  return _updateMwFeePrice.apply(this, arguments);
} // Function to attach event listener to MW fee checkbox
function _updateMwFeePrice() {
  _updateMwFeePrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var mwFeeElement, priceSpan, calculatedPrice;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          mwFeeElement = document.querySelector('.cart__form .mw-fee--type-cart, .cart__form .mw-fee[data-fee-target-key]');
          if (!mwFeeElement) {
            _context7.next = 9;
            break;
          }
          priceSpan = mwFeeElement.querySelector('.mw-fee-price-span');
          if (!priceSpan) {
            _context7.next = 9;
            break;
          }
          _context7.next = 6;
          return calculateMwFeePrice();
        case 6:
          calculatedPrice = _context7.sent;
          priceSpan.textContent = "$".concat(calculatedPrice.toFixed(2));
          console.log('MW Fee price updated:', calculatedPrice);
        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _updateMwFeePrice.apply(this, arguments);
}
function attachMwFeeCheckboxListener() {
  var mwFeeCheckbox = document.querySelector('input.mw-fee__control--type-checkbox');
  if (mwFeeCheckbox && !mwFeeCheckbox.hasAttribute('data-listener-attached')) {
    mwFeeCheckbox.addEventListener('change', function (event) {
      console.log('MW Fee checkbox changed:', event.target.checked);

      // Trigger the same cart refresh behavior as normal cart changes
      // First dispatch theme:cart:refresh to update the cart content
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
          bubbles: true
        }));

        // Then after a short delay, dispatch the same events that happen during normal cart changes
        setTimeout(function () {
          // Get updated cart data and dispatch theme:cart:change like normal cart updates do
          fetch('/cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            return response.json();
          }).then(function (cart) {
            // Dispatch theme:cart:change with cart count like normal cart changes
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              bubbles: true,
              detail: {
                cartCount: cart.item_count
              }
            }));

            // Also dispatch cart:updated for any functionality that depends on it
            document.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart: cart
              }
            }));
          })["catch"](function (error) {
            console.error('Failed to fetch cart data for MW fee change:', error);
          });
        }, 100);
      }, 1000);
    });

    // Mark as having listener attached to prevent duplicate listeners
    mwFeeCheckbox.setAttribute('data-listener-attached', 'true');
    console.log('MW Fee checkbox event listener attached');
  }
}

// Function to stop MW fee observer
function stopMwFeeObserver() {
  if (mwFeeObserver) {
    mwFeeObserver.disconnect();
    mwFeeObserver = null;
    console.log('MW Fee mutation observer stopped');
  }
}

// Store observers globally so they can be stopped
var mwFeeObserver = null;

// Observer to watch for dynamically added MW fee elements
function observeForMwFee() {
  var cartDrawer = document.querySelector('#cart-drawer, [data-cart-drawer], .drawer--cart');
  if (!cartDrawer || mwFeeObserver) return; // Don't create multiple observers

  mwFeeObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Element node
          // Check if the added node is the MW fee div (multiple possible selectors)
          if (node.matches && (node.matches('.mw-fee--type-cart') || node.matches('.mw-fee[data-fee-target-key]') || node.matches('[data-fee-target-key]'))) {
            setTimeout(function () {
              if (moveMwFeeToCartForm()) {
                // Success - stop observing
                return;
              }
            }, 100);
          }

          // Check if the added node contains MW fee div (multiple possible selectors)
          var mwFeeDiv = node.querySelector && (node.querySelector('.cart__total .mw-fee--type-cart') || node.querySelector('.mw-fee--type-cart') || node.querySelector('.mw-fee[data-fee-target-key]') || node.querySelector('[data-fee-target-key]'));
          if (mwFeeDiv) {
            setTimeout(function () {
              if (moveMwFeeToCartForm()) {
                // Success - stop observing
                return;
              }
            }, 100);
          }

          // Also check if MW fee checkbox was added and attach listener
          if (node.matches && node.matches('input.mw-fee__control--type-checkbox')) {
            setTimeout(function () {
              attachMwFeeCheckboxListener();
            }, 1000);
          }

          // Check if the added node contains MW fee checkbox
          var mwFeeCheckbox = node.querySelector && node.querySelector('input.mw-fee__control--type-checkbox');
          if (mwFeeCheckbox) {
            setTimeout(function () {
              attachMwFeeCheckboxListener();
            }, 1000);
          }
        }
      });
    });
  });

  // Start observing
  mwFeeObserver.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

// Initialize MW Fee functionality
document.addEventListener("DOMContentLoaded", function () {
  // Try to move existing mw-fee first
  setTimeout(function () {
    if (!moveMwFeeToCartForm()) {
      // If not found initially, start observing
      observeForMwFee();
    } else {
      // If MW fee was found and moved/exists, make sure price span is added
      var mwFeeElement = document.querySelector('.cart__form .mw-fee--type-cart, .cart__form .mw-fee[data-fee-target-key]');
      if (mwFeeElement) {
        addMwFeePriceSpan(mwFeeElement);
      }
    }
    // Also try to attach checkbox listener if MW fee checkbox already exists
    attachMwFeeCheckboxListener();
  }, 500);
});

// Handle cart updates
document.addEventListener('cart:updated', function () {
  setTimeout(function () {
    if (!moveMwFeeToCartForm()) {
      // If not found, restart observing if not already active
      observeForMwFee();
    } else {
      // If MW fee was found and moved/exists, make sure price span is added
      var mwFeeElement = document.querySelector('.cart__form .mw-fee--type-cart, .cart__form .mw-fee[data-fee-target-key]');
      if (mwFeeElement) {
        addMwFeePriceSpan(mwFeeElement);
      }
    }
    // Also try to attach checkbox listener
    attachMwFeeCheckboxListener();
    // Update MW fee price
    updateMwFeePrice();
  }, 200);
});

// Handle theme events for cart changes
document.addEventListener('theme:cart:add', function () {
  setTimeout(function () {
    if (!moveMwFeeToCartForm()) {
      observeForMwFee();
    } else {
      // If MW fee was found and moved/exists, make sure price span is added
      var mwFeeElement = document.querySelector('.cart__form .mw-fee--type-cart, .cart__form .mw-fee[data-fee-target-key]');
      if (mwFeeElement) {
        addMwFeePriceSpan(mwFeeElement);
      }
    }
    // Also try to attach checkbox listener
    attachMwFeeCheckboxListener();
    // Update MW fee price
    updateMwFeePrice();
  }, 300);
});
document.addEventListener('theme:cart:change', function () {
  setTimeout(function () {
    if (!moveMwFeeToCartForm()) {
      observeForMwFee();
    } else {
      // If MW fee was found and moved/exists, make sure price span is added
      var mwFeeElement = document.querySelector('.cart__form .mw-fee--type-cart, .cart__form .mw-fee[data-fee-target-key]');
      if (mwFeeElement) {
        addMwFeePriceSpan(mwFeeElement);
      }
    }
    // Also try to attach checkbox listener
    attachMwFeeCheckboxListener();
    // Update MW fee price
    updateMwFeePrice();
  }, 300);
});

// Handle Shopify section reloads (theme editor)
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('[data-section-type="cart-drawer"]') || event.target.querySelector('.cart__foot__inner')) {
    setTimeout(function () {
      if (!moveMwFeeToCartForm()) {
        // If not found, restart observing
        observeForMwFee();
      } else {
        // If MW fee was found and moved/exists, make sure price span is added
        var mwFeeElement = document.querySelector('.cart__form .mw-fee--type-cart, .cart__form .mw-fee[data-fee-target-key]');
        if (mwFeeElement) {
          addMwFeePriceSpan(mwFeeElement);
        }
      }
      // Also try to attach checkbox listener
      attachMwFeeCheckboxListener();
    }, 300);
  }
});

// Additional event listeners for cart drawer interactions - MW Fee
document.addEventListener('click', function (event) {
  // Check if cart drawer trigger was clicked
  if (event.target.matches('[data-cart-drawer-open], [data-cart-open], .cart-link, .cart__toggle') || event.target.closest('[data-cart-drawer-open], [data-cart-open], .cart-link, .cart__toggle')) {
    setTimeout(function () {
      if (!moveMwFeeToCartForm()) {
        // If not found, start observing if not already active
        observeForMwFee();
      } else {
        // If MW fee was found and moved/exists, make sure price span is added
        var mwFeeElement = document.querySelector('.cart__form .mw-fee--type-cart, .cart__form .mw-fee[data-fee-target-key]');
        if (mwFeeElement) {
          addMwFeePriceSpan(mwFeeElement);
        }
      }
      // Also try to attach checkbox listener
      attachMwFeeCheckboxListener();
    }, 500);
  }
});

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;